var React = require('react');

function Layers (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"12 2 2 7 12 12 22 7 12 2","key":0}),React.createElement("polyline",{"points":"2 17 12 22 22 17","key":1}),React.createElement("polyline",{"points":"2 12 12 17 22 12","key":2})]);
}

Layers.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-layers"};

module.exports = Layers;

Layers.default = Layers;
